import { render } from "./ModalFileUpload.vue?vue&type=template&id=5f55a999&ts=true"
import script from "./ModalFileUpload.vue?vue&type=script&lang=ts"
export * from "./ModalFileUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__